var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailscaleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 24,
    viewBox: "0 0 121 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-a1",
    opacity: 0.2,
    cx: 3.4,
    cy: 3.25,
    r: 2.7,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-a2",
    cx: 3.4,
    cy: 11.3,
    r: 2.7,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-a3",
    opacity: 0.2,
    cx: 3.4,
    cy: 19.5,
    r: 2.7,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-b1",
    cx: 11.5,
    cy: 11.3,
    r: 2.7,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-b2",
    cx: 11.5,
    cy: 19.5,
    r: 2.7,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-b3",
    opacity: 0.2,
    cx: 11.5,
    cy: 3.25,
    r: 2.7,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-c1",
    opacity: 0.2,
    cx: 19.5,
    cy: 3.25,
    r: 2.7,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-c2",
    cx: 19.5,
    cy: 11.3,
    r: 2.7,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "dot dot-c3",
    opacity: 0.2,
    cx: 19.5,
    cy: 19.5,
    r: 2.7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4135 20.0991C39.1764 20.0991 39.7963 20.0276 40.5354 19.8845V17.1188C40.0824 17.2857 39.5817 17.3334 39.1049 17.3334C37.9366 17.3334 37.5075 16.7612 37.5075 15.6645V10.0378H40.5354V7.2721H37.5075V3.17128H34.1696V7.2721H32V10.0378H34.1696V15.9744C34.1696 18.597 35.5525 20.0991 38.4135 20.0991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9867 20.0991C47.7748 20.0991 48.9669 19.503 49.563 18.5732C49.6106 18.9785 49.7537 19.5269 49.9444 19.8607H52.9485C52.7816 19.2884 52.6624 18.3825 52.6624 17.7864V11.2537C52.6624 8.55957 50.7312 7.03368 47.4649 7.03368C44.9853 7.03368 43.0541 7.96352 41.9812 9.32251L43.8886 11.206C44.7469 10.2523 45.8436 9.75166 47.1788 9.75166C48.8 9.75166 49.5153 10.3 49.5153 11.1107C49.5153 11.8021 49.0384 12.2789 46.4635 12.2789C43.9839 12.2789 41.4805 13.3041 41.4805 16.1652C41.4805 18.8116 43.3879 20.0991 45.9867 20.0991ZM46.6542 17.5718C45.3668 17.5718 44.7707 17.0235 44.7707 16.0459C44.7707 15.1876 45.486 14.6154 46.6781 14.6154C48.5854 14.6154 49.11 14.4962 49.5153 14.0909V15.1161C49.5153 16.4751 48.3709 17.5718 46.6542 17.5718Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8322 5.67469H58.3131V2.55139H54.8322V5.67469ZM54.9037 19.8607H58.2416V7.2721H54.9037V19.8607Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6733 19.8607H64.0112V2.93286H60.6733V19.8607Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.949 20.0991C74.6207 20.0991 76.5042 18.1679 76.5042 16.1413C76.5042 14.3055 75.5744 12.9465 72.5226 12.3981C70.3768 12.0167 69.0417 11.5398 69.0417 10.8007C69.0417 10.157 69.8046 9.70398 71.0921 9.70398C72.2365 9.70398 73.1902 10.0855 73.9054 10.9199L76.0274 9.13177C74.9545 7.79662 73.1902 7.03368 71.0921 7.03368C67.8734 7.03368 65.8707 8.7503 65.8707 10.8484C65.8707 13.1372 67.9688 14.1624 70.2338 14.5677C72.1173 14.9015 73.1663 15.2592 73.1663 16.0698C73.1663 16.7612 72.4272 17.3334 71.0205 17.3334C69.6377 17.3334 68.5648 16.6897 68.0641 15.736L65.2508 17.0711C65.9422 18.7878 68.3026 20.0991 70.949 20.0991Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9665 20.0991C86.3507 20.0991 88.0674 19.1454 89.3548 16.9996L86.6845 15.6406C86.1838 16.642 85.3732 17.3334 83.9665 17.3334C81.8446 17.3334 80.7002 15.6168 80.7002 13.5425C80.7002 11.4683 81.9161 9.79935 83.9665 9.79935C85.254 9.79935 86.1123 10.4908 86.613 11.5398L89.3071 10.1093C88.4011 8.13041 86.613 7.03368 83.9665 7.03368C79.6035 7.03368 77.3623 10.2285 77.3623 13.5425C77.3623 17.1427 80.0803 20.0991 83.9665 20.0991Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 20.0991C96.4599 20.0991 97.652 19.503 98.2481 18.5732C98.2957 18.9785 98.4388 19.5269 98.6295 19.8607H101.634C101.467 19.2884 101.348 18.3825 101.348 17.7864V11.2537C101.348 8.55957 99.4163 7.03368 96.15 7.03368C93.6704 7.03368 91.7392 7.96352 90.6663 9.32251L92.5737 11.206C93.432 10.2523 94.5287 9.75166 95.8639 9.75166C97.4851 9.75166 98.2004 10.3 98.2004 11.1107C98.2004 11.8021 97.7235 12.2789 95.1486 12.2789C92.669 12.2789 90.1656 13.3041 90.1656 16.1652C90.1656 18.8116 92.073 20.0991 94.6718 20.0991ZM95.3393 17.5718C94.0519 17.5718 93.4558 17.0235 93.4558 16.0459C93.4558 15.1876 94.1711 14.6154 95.3632 14.6154C97.2705 14.6154 97.7951 14.4962 98.2004 14.0909V15.1161C98.2004 16.4751 97.056 17.5718 95.3393 17.5718Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.309 19.8607H106.647V2.93286H103.309V19.8607Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.658 20.0991C117.114 20.0991 119.093 19.1216 120.189 17.3811L117.662 15.7598C116.995 16.8089 116.112 17.3811 114.658 17.3811C113.013 17.3811 111.821 16.4751 111.511 14.7108H121V13.5425C121 10.2285 118.973 7.03368 114.634 7.03368C110.51 7.03368 108.268 10.2523 108.268 13.5664C108.268 18.2871 111.821 20.0991 114.658 20.0991ZM111.63 12.0882C112.155 10.4908 113.251 9.75166 114.706 9.75166C116.351 9.75166 117.352 10.7292 117.686 12.0882H111.63Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailscaleDark);
export default __webpack_public_path__ + "static/media/tailscale-dark.6404a511865ff09c052af5d4b5df07cc.svg";
export { ForwardRef as ReactComponent };